import React from "react";
import PropTypes from "prop-types";

const StatusLocked = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "#7F7F7F",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30,3.6c14.6,0,26.4,11.8,26.4,26.4S44.6,56.4,30,56.4S3.6,44.6,3.6,30S15.4,3.6,30,3.6z M30,0 C13.4,0,0,13.4,0,30s13.4,30,30,30s30-13.4,30-30S46.6,0,30,0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.2,30.7c0-0.4-0.4-0.9-0.8-1c-0.5-0.2-0.9-0.3-1.4-0.5v-5.3C39.1,19,35,15,30,15c-5,0-9.1,4-9.1,8.9v5.3 c-0.5,0.2-0.9,0.3-1.4,0.5c-0.4,0.2-0.7,0.6-0.8,1h0v0.1v0.2v11c0,0.5,0.3,0.9,0.8,1.1c3.4,1.3,6.9,2,10.5,2c3.6,0,7.1-0.7,10.5-2 c0.4-0.2,0.8-0.6,0.8-1.1v-11L41.2,30.7L41.2,30.7L41.2,30.7z M31.2,36v4c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2v-4 c-0.7-0.4-1.2-1.2-1.2-2c0-1.3,1.1-2.4,2.5-2.4c1.4,0,2.5,1.1,2.5,2.4C32.5,34.8,32,35.6,31.2,36z M36,28.3c-2-0.4-3.9-0.6-6-0.6 c-2,0-4,0.2-6,0.6v-4.4c0-3.2,2.7-5.8,6-5.8c3.3,0,6,2.6,6,5.8V28.3z"
}));

StatusLocked.propTypes = {
  className: PropTypes.string
};
export default StatusLocked;